module.exports = __webpack_public_path__ + "img/edi-8.85662909.png";